<template>
  <div class="kalem">
    <resultDialog ref="showMessage"></resultDialog>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card flat>
      <v-layout row wrap>
        <v-flex xs12 pr-2 md9 sm9>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-tabs
                slot="extension"
                color="grey lighten-4"
                v-model="tabmodel"
              >
                <v-menu bottom right offset-y>
                  <v-btn slot="activator" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile
                      v-for="(item, i) in menuItems"
                      :key="i"
                      @click="menuClick(i)"
                    >
                      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <v-tab :href="`#tab-genel`">{{ $t('tab_general') }}</v-tab>
                <v-tab :href="`#tab-ozel`"> {{ $t('Private-Information')}} </v-tab>

                <v-tab :href="`#tab-ekstralar`">{{ $t('Extras') }}</v-tab>
                <v-tab :href="`#tab-maliyet`">{{$t('Cost')}}</v-tab>
                <v-tab :href="`#tab-komisyon`">{{$t('Commission')}}</v-tab>
                <v-tab :href="`#tab-aciklama`">{{ $t('Description') }}</v-tab>
                <v-tab :href="`#tab-diger`">{{ $t('Other') }}</v-tab>
              </v-tabs>
            </v-flex>

            <v-flex xs12 sm12>
              <v-tabs-items v-model="tabmodel">
                <v-tab-item :id="`tab-genel`">
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-card flat color="grey lighten-5">
                        <v-layout row wrap>
                          <v-flex xs12 sm4 md4>
                            <v-layout row wrap>
                              <v-flex pl-1 xs11 sm11 md11>
                                <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  :tip="val.kalem.saticiTip"
                                  :label="$t('Seller-Code')"
                                  v-model="val.kalem.satici"
                                ></genelarama>
                              </v-flex>

                              <v-flex xs1 sm1 md1>
                                <v-layout
                                  row
                                  wrap
                                  fill-height
                                  align-end
                                  justify-center
                                >
                                  <minisaticieklecomp
                                    v-model="val.kalem.satici"
                                    :label="'Rent a Car Satıcı Ekle'"
                                    :saticiKod="val.kalem.saticiTip"
                                  >
                                  </minisaticieklecomp>
                                </v-layout>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                <genelarama
                                  apiname="SaticiAra"
                                  :tip="12"
                                  :label="$t('Tour-Operator')"
                                  v-model="val.kalem.turOperatoru"
                                ></genelarama>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                <v-select
                                  hide-details
                                  :items="odemeTipi"
                                  :label="$t('Payment-Type')"
                                  item-text="aciklama"
                                  item-value="kod"
                                  v-model="val.kalem.odeyenTaraf"
                                >
                                </v-select>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                <rentacarkategori
                                  :label="$t('Category')"
                                  :getcode="val.kalem.satici"
                                  v-model="val.kalem.kalemRentACar.kategori"
                                >
                                </rentacarkategori>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                
                                <rentacararac
                                  hide-details
                                  :kategori="val.kalem.kalemRentACar.kategori"
                                  :getcode="val.kalem.satici"
                                  v-model="val.kalem"
                                >
                                </rentacararac>
                              </v-flex>

                              <v-flex xs12 pl-1 sm12 md12>
                                <v-text-field
                                  mask="###"
                                  hide-details
                                  :label="$t('Number')"
                                  v-model="val.kalem.kalemRentACar.aracAdet"
                                >
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex pl-1 xs4 sm4 md4>
                            <v-layout row wrap>
                              <v-flex pl-1 xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs6 sm6 md6>
                                    <tarihcomp
                                      :etiket="$t('Purchase-Date')"
                                      v-bind:detaygizle="true"
                                      v-bind:defaultvalue="'ok'"
                                      v-bind:value="
                                        val.kalem.kalemRentACar.alisTarih
                                      "
                                      v-model="
                                        val.kalem.kalemRentACar.alisTarih
                                      "
                                    >
                                    </tarihcomp>
                                  </v-flex>

                                  <v-flex xs6 sm6 md6>
                                    <v-menu
                                      ref="menualissati"
                                      v-model="menualissati"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      :return-value.sync="
                                        val.kalem.kalemRentACar.alisSaat
                                      "
                                      transition="scale-transition"
                                      offset-y
                                      full-width
                                      max-width="290px"
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          hide-details
                                          v-model="
                                            val.kalem.kalemRentACar.alisSaat
                                          "
                                          :label="this.$t('Pickup-Time')"
                                          append-icon="access_time"
                                          v-on="on"
                                        >
                                        </v-text-field>
                                      </template>
                                      <v-time-picker
                                        v-if="menualissati"
                                        format="24hr"
                                        v-model="
                                          val.kalem.kalemRentACar.alisSaat
                                        "
                                        full-width
                                        @click:minute="
                                          $refs.menualissati.save(
                                            val.kalem.kalemRentACar.alisSaat
                                          )
                                        "
                                      >
                                      </v-time-picker>
                                    </v-menu>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs6 sm6 md6>
                                    <tarihcomp
                                      :etiket="$t('Delivery-Date')"
                                      v-bind:detaygizle="true"
                                      v-bind:defaultvalue="'yes'"
                                      v-bind:value="val.kalem.donem2"
                                      v-model="val.kalem.donem2"
                                    >
                                    </tarihcomp>
                                  </v-flex>

                                  <v-flex xs6 sm6 md6>
                                    <v-menu
                                      ref="menuteslimsati"
                                      v-model="menuteslimsati"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      :return-value.sync="
                                        val.kalem.kalemRentACar.teslimSaat
                                      "
                                      transition="scale-transition"
                                      offset-y
                                      full-width
                                      max-width="290px"
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          hide-details
                                          v-model="
                                            val.kalem.kalemRentACar.teslimSaat
                                          "
                                          :label="$t('Delivery-Time')"
                                          append-icon="access_time"
                                          v-on="on"
                                        >
                                        </v-text-field>
                                      </template>
                                      <v-time-picker
                                        v-if="menuteslimsati"
                                        format="24hr"
                                        v-model="
                                          val.kalem.kalemRentACar.teslimSaat
                                        "
                                        full-width
                                        @click:minute="
                                          $refs.menuteslimsati.save(
                                            val.kalem.kalemRentACar.teslimSaat
                                          )
                                        "
                                      >
                                      </v-time-picker>
                                    </v-menu>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex pl-1 xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs6 sm6 md6>
                                    <tarihcomp
                                      :etiket="$t('Client-Delivery-Date')"
                                      v-bind:detaygizle="true"
                                      v-bind:defaultvalue="'yes'"
                                      v-bind:value="
                                        val.kalem.kalemRentACar
                                          .musteriTeslimTarihi
                                      "
                                      v-model="
                                        val.kalem.kalemRentACar
                                          .musteriTeslimTarihi
                                      "
                                    >
                                    </tarihcomp>
                                  </v-flex>

                                  <v-flex xs6 sm6 md6>
                                    <v-menu
                                      ref="menumusteslimsati"
                                      v-model="menumusteslimsati"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      :return-value.sync="
                                        val.kalem.kalemRentACar
                                          .musteriTeslimSaati
                                      "
                                      transition="scale-transition"
                                      offset-y
                                      full-width
                                      max-width="290px"
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          hide-details
                                          v-model="
                                            val.kalem.kalemRentACar
                                              .musteriTeslimSaati
                                          "
                                          :label="$t('Client-Delivery-Time')"
                                          append-icon="access_time"
                                          v-on="on"
                                        >
                                        </v-text-field>
                                      </template>
                                      <v-time-picker
                                        v-if="menumusteslimsati"
                                        format="24hr"
                                        v-model="
                                          val.kalem.kalemRentACar
                                            .musteriTeslimSaati
                                        "
                                        full-width
                                        @click:minute="
                                          $refs.menumusteslimsati.save(
                                            val.kalem.kalemRentACar
                                              .musteriTeslimSaati
                                          )
                                        "
                                      >
                                      </v-time-picker>
                                    </v-menu>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-text-field
                                  hide-details
                                  :label="$t('Place-of-Purchase')"
                                  v-model="val.kalem.kalemRentACar.alisYeri"
                                >
                                </v-text-field>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-text-field
                                  hide-details
                                  :label="$t('Delivery-Place')"
                                  v-model="val.kalem.kalemRentACar.teslimYeri"
                                >
                                </v-text-field>
                              </v-flex>

                              <v-flex xs12 sm6 md6>
                                <v-text-field
                                  mask="###"
                                  hide-details
                                  :label="$t('Time-Option')"
                                  v-model="val.kalem.kalemRentACar.saatOpsiyonu"
                                >
                                </v-text-field>
                              </v-flex>

                              <v-flex xs12 sm6 md6>
                                <v-text-field
                                  mask="###"
                                  hide-details
                                  :label="$t('Number-of-Days')"
                                  v-model="val.kalem.kalemRentACar.gun"
                                >
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex pl-1 xs4 sm4 md4>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <kur
                                  v-model="val.kalem.satisPara"
                                  :kurtarihi="val.Rez.kayitTarihi"
                                ></kur>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <yuzdeinput
                                :isPositive="true"
                                  :etiket="$t('VAT-Ratio')"
                                  v-model="val.kalem.satis.KDVOran"
                                  :autocomplete="'autocomplete'"
                                  :maxValue="30"
                                ></yuzdeinput>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-radio-group
                                  row
                                  hide-details
                                  v-model="val.kalem.P_RP"
                                  column
                                >
                                  <v-radio label="Pax" :value="'P'"></v-radio>
                                  <v-radio :label="$t('Fix')" :value="'R'"></v-radio>
                                </v-radio-group>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs8 sm8 md8>
                                    <parainput
                                    :isPositive="true"
                                     simge=""
                                      :etiket="$t('Adult-Sales')"
                                      v-model="val.kalem.yet_Satis"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                  <v-flex xs4 sm4 md4>
                                    <v-text-field
                                      hide-details
                                      mask="#####"
                                      v-model="val.kalem.yet_KisiSayisi"
                                      :label="$t('Number')"
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs6 sm6 md6>
                                    <yuzdeinput
                                    :isPositive="true"
                                      :etiket="$t('Discount-rate')"
                                      v-model="val.kalem.iskonto.oran"
                                      :autocomplete="'autocomplete'"
                                    ></yuzdeinput>
                                  </v-flex>
                                  <v-flex xs6 sm6 md6>
                                    <parainput
                                    :isPositive="true"
                                     simge=""
                                      :etiket="$t('Discount-Amount')"
                                      v-model="val.kalem.iskonto.tutar"
                                      :autocomplete="'autocomplete'"
                                    ></parainput>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex pb-2 xs12 sm12 md12>
                                <v-text-field
                                  hide-details
                                  :label="$t('Discount-Reason')"
                                  v-model="val.kalem.iskonto.iskontoSebebi"
                                >
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-tab-item>
                <v-tab-item :id="`tab-ozel`">
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-card flat color="grey lighten-5">
                        <v-layout row wrap>
                          <v-flex xs12 sm4 md4>
                            <v-layout row wrap>
                              <v-flex pl-1 pb-2 xs12 sm12 md12>
                                <v-layout row wrap>
                                  <v-flex xs12 sm12 md12>
                                    <genelarama
                                      apiname="MasrafMerkeziAra"
                                      :label="$t('Expense-Center-v2')"
                                      v-model="val.kalem.masrafMerkezi"
                                    >
                                    </genelarama>
                                  </v-flex>
                                  <v-flex xs12 sm12 md12>
                                    <geneltipara
                                      tip="AcenteDepartman"
                                      v-model="val.kalem.departman"
                                    >
                                    </geneltipara>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-tab-item>

                <v-tab-item :id="`tab-ekstralar`">
                  <v-layout row wrap>
                    <v-flex xs12 sm12>
                      <v-card flat color="grey lighten-5">
                        <v-flex xs12 sm12 pa-1 md12>
                          <v-layout row wrap>
                            <v-flex xs12 sm6 pa-1 md6>
                              <v-layout row wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-checkbox
                                    v-model="
                                      val.kalem.kalemRentACar.checkDropUcreti
                                    "
                                    :label="$t('Drop-Price')"
                                    color="info"
                                    hide-details
                                  >
                                  </v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <parainput
                                  :isPositive="true"
                                   simge=""
                                    :etiket="''"
                                    v-model="val.kalem.kalemRentACar.dropUcreti"
                                    :autocomplete="'autocomplete'"
                                  ></parainput>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-checkbox
                                    v-model="
                                      val.kalem.kalemRentACar.checkBebekKoltugu
                                    "
                                    :label="$t('Baby-Seat')"
                                    color="info"
                                    hide-details
                                  >
                                  </v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <parainput
                                  :isPositive="true"
                                   simge=""
                                    :etiket="''"
                                    v-model="
                                      val.kalem.kalemRentACar.bebekKoltugu
                                    "
                                    :autocomplete="'autocomplete'"
                                  ></parainput>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-checkbox
                                    v-model="
                                      val.kalem.kalemRentACar.checkCocukKoltugu
                                    "
                                    :label="$t('Children-Seat')"
                                    color="info"
                                    hide-details
                                  >
                                  </v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <parainput
                                  :isPositive="true"
                                   simge=""
                                    :etiket="''"
                                    v-model="
                                      val.kalem.kalemRentACar.cocukKoltugu
                                    "
                                    :autocomplete="'autocomplete'"
                                  ></parainput>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-checkbox
                                    v-model="
                                      val.kalem.kalemRentACar.checkOtomatikVites
                                    "
                                    :label="$t('Automatic-Gear')"
                                    color="info"
                                    hide-details
                                  >
                                  </v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <parainput
                                  :isPositive="true"
                                   simge=""
                                    :etiket="''"
                                    v-model="
                                      val.kalem.kalemRentACar.otomatikVites
                                    "
                                    :autocomplete="'autocomplete'"
                                  ></parainput>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-checkbox
                                    v-model="val.kalem.kalemRentACar.checkKlima"
                                    :label="$t('Air-conditioning')"
                                    color="info"
                                    hide-details
                                  >
                                  </v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <parainput
                                  :isPositive="true"
                                   simge=""
                                    :etiket="''"
                                    v-model="val.kalem.kalemRentACar.klima"
                                    :autocomplete="'autocomplete'"
                                  ></parainput>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm6 pa-1 md6>
                              <v-layout row wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-checkbox
                                    v-model="
                                      val.kalem.kalemRentACar.checkTemizlik
                                    "
                                    :label="$t('Seat-Cleaning')"
                                    color="info"
                                    hide-details
                                  >
                                  </v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <parainput
                                  :isPositive="true"
                                   simge=""
                                    :etiket="''"
                                    v-model="val.kalem.kalemRentACar.temizlik"
                                    :autocomplete="'autocomplete'"
                                  ></parainput>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-checkbox
                                    v-model="
                                      val.kalem.kalemRentACar
                                        .checkIptalSigortasi
                                    "
                                    :label="$t('Cancellation-Insurance')"
                                    color="info"
                                    hide-details
                                  >
                                  </v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <parainput
                                  :isPositive="true"
                                   simge=""
                                    :etiket="''"
                                    v-model="
                                      val.kalem.kalemRentACar.iptalSigortasi
                                    "
                                    :autocomplete="'autocomplete'"
                                  ></parainput>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-checkbox
                                    v-model="
                                      val.kalem.kalemRentACar.checkNavigation
                                    "
                                    :label="$t('Navigation')"
                                    color="info"
                                    hide-details
                                  >
                                  </v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <parainput
                                  :isPositive="true"
                                   simge=""
                                    :etiket="''"
                                    v-model="val.kalem.kalemRentACar.navigation"
                                    :autocomplete="'autocomplete'"
                                  ></parainput>
                                </v-flex>
                              </v-layout>

                              <v-layout row wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-checkbox
                                    v-model="val.kalem.kalemRentACar.checkDiger"
                                    :label="$t('Other') "
                                    color="info"
                                    hide-details
                                  >
                                  </v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <parainput
                                  :isPositive="true"
                                   simge=""
                                    :etiket="''"
                                    v-model="val.kalem.kalemRentACar.diger"
                                    :autocomplete="'autocomplete'"
                                  ></parainput>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-tab-item>

                <v-tab-item :id="`tab-maliyet`">
                  <v-layout row wrap>
                    <v-card flat color="grey lighten-5">
                      <v-flex xs12 sm12 pa-1 md12>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md11>
                            <cariaracomp
                              v-bind:etiket="$t('Cost-Current')"
                              v-bind:value="val.kalem.maliyetCariKod.kod"
                              v-model="val.kalem.maliyetCariKod.kod"
                              :Coper="true"
                            ></cariaracomp>
                          </v-flex>
                              <v-flex xs12 sm12 md1 pt-2>
                            <v-tooltip bottom>
                               <v-btn @click="getMaliyetCari()"  slot="activator" flat icon color="primary">
                              <v-icon>swipe_left_alt</v-icon>
                            </v-btn>
                            <span> {{$t('Bring-Seller-Client')}} </span>
                            </v-tooltip>
                           </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-text-field
                              hide-details
                              :label="$t('Profit-VAT')"
                              mask="#####"
                              v-model="val.kalem.karKDV"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <kur
                              v-model="val.kalem.alisPara"
                              :kurtarihi="val.Rez.kayitTarihi"
                            >
                            </kur>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <template v-if="val.kalem.saticiTip == 1">
                              <v-combobox
                                hide-details
                                :label="$t('Rom-Pax-Total')"
                                v-model="val.kalem.kalemOtel.RP"
                                :items="['R', 'P', 'T']"
                              >
                              </v-combobox>
                            </template>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <kredikartodemetipi
                              v-model="val.kalem.KKartOdemeTipi"
                              @input="kKartKontrol()"
                            ></kredikartodemetipi>
                          </v-flex>
                          <v-flex xs12 sm12 md6>
                            <kredikartnoara
                              v-bind:value="val.kalem.KKartNo"
                              v-model="val.kalem.KKartNo"
                              v-bind:kartTipi="val.kalem.KKartOdemeTipi"
                            ></kredikartnoara>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <parainput
                            :isPositive="true"
                             simge=""
                              :etiket="$t('YetBuying')"
                              v-model="val.kalem.yet_Alis"
                              :autocomplete="'autocomplete'"
                            >
                            </parainput>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card>
                  </v-layout>
                </v-tab-item>

                <v-tab-item :id="`tab-komisyon`">
                  <v-layout row wrap>
                    <v-card flat color="grey lighten-5">
                      <v-flex xs12 sm12 pa-1 md12>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-autocomplete
                              hide-details
                              :label="$t('Calculate-Commission-Percentage')"
                              v-model="val.kalem.komisyonYuzdeTip"
                              item-text="t"
                              item-value="v"
                              :items="[
                                { t: $t('Calculate-From-Sales-Price'), v: 0 },
                                { t: $t('Calculate-From-Purchasing-Price'), v: 1 },
                              ]"
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <yuzdeinput
                            :isPositive="true"
                              :etiket="$t('Commission-Percentage')"
                              v-model="val.kalem.komisyonYuzde"
                              :autocomplete="'autocomplete'"
                            ></yuzdeinput>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <parainput
                            :isPositive="true"
                             simge=""
                              :etiket="$t('Commission-Amount-v2')"
                              v-model="val.kalem.komisyonTutar"
                              :autocomplete="'autocomplete'"
                            ></parainput>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <kur
                              v-model="val.kalem.komisyonPara"
                              :kurtarihi="val.Rez.kayitTarihi"
                            >
                            </kur>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                           <v-text-field
                              :label="$t('Commission-VAT')"
                              v-model="val.kalem.komisyon.KDVOran"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card>
                  </v-layout>
                </v-tab-item>

                <v-tab-item :id="`tab-aciklama`">
                  <v-card flat color="grey lighten-5">
                    <v-flex xs12 sm12 pa-1 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <v-textarea
                            hide-details
                            :label="$t('Descriptions')"
                            v-model="val.kalem.aciklama"
                          >
                          </v-textarea>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-textarea
                            hide-details
                            :label="$t('Supplier-Explanations')"
                            v-model="val.kalem.tedarikciAciklama"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card>
                </v-tab-item>

                <v-tab-item :id="`tab-diger`">
                  <v-card flat color="grey lighten-5">
                    <v-flex xs12 sm12 pa-1 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <v-text-field
                            hide-details
                            :label="$t('Integration-Code')"
                            v-model="val.kalem.entegrasyonKodu"
                          >
                          </v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <geneltipara
                            tip="CariKdvKod"
                            hide-details
                            :label="$t('VAT-Code')"
                            v-model="val.kalem.kdvID"
                          >
                          </geneltipara>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <geneltipara
                            tip="CariKdvIstisnaKod"
                            hide-details
                            :label="$t('VAT-Exception-Code')"
                            v-model="val.kalem.kdvMuafiyetID"
                          >
                          </geneltipara>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md3 sm3>
          <v-flex xs12 sm12 md12>
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 pa-2 sm12 md12>
                  <v-layout row wrap>
                    <v-flex pl-1 xs12 sm12 md12>
                      <v-layout justify-center>
                        <v-checkbox
                          v-model="tumunusec"
                          :label="$t('Person-List')"
                          color="info"
                          hide-details
                        >
                        </v-checkbox>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>

                <v-flex
                  pa-2
                  v-for="item in val.Kisiler"
                  v-bind:key="item.id"
                  xs12
                  sm12
                  md12
                >
                  <v-card flat="">
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex xs2 sm2 md2>
                              <v-layout
                                align-start=""
                                justify-start
                                fill-height
                              >
                                <v-card flat="">
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>
                                      <div
                                        class="font-weight grey--text caption"
                                      >
                                        <v-checkbox
                                          v-model="secilenkayitlar"
                                          :value="item"
                                          hide-details
                                        >
                                        </v-checkbox>
                                      </div>
                                    </v-list-tile-sub-title>
                                    <v-list-tile-sub-title>
                                      <div
                                        class="font-weight green--text body-2"
                                      >
                                        &nbsp;
                                      </div>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-card>
                              </v-layout>
                            </v-flex>
                            <v-flex xs5 sm5 md5>
                              <v-layout
                                align-center=""
                                justify-start=""
                                fill-height=""
                              >
                                <v-icon color="red">person</v-icon>
                                <span
                                  class="caption black--text font-weight-regular"
                                >
                                  {{ KisiTipToStr(item.kisiTip) }}
                                </span>
                              </v-layout>
                            </v-flex>

                            <v-flex xs5 sm5 md5>
                              <v-layout
                                align-center=""
                                justify-start=""
                                fill-height=""
                              >
                                <span
                                  class="caption black--text font-weight-regular"
                                >
                                  {{ item.adSoyad }}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 pa-2 sm12 md12>
                  <v-layout row wrap>
                    <v-flex v-if="val.islem == 'new'" pb-1 xs12 sm12 md12>
                      <v-btn outline @click="kalemekle()" block color="info">
                        {{$t('Add-Reservation-List')}}</v-btn
                      >
                    </v-flex>
                    <v-flex
                      @click="kalemguncelle()"
                      v-if="val.islem == 'edit'"
                      pb-1
                      xs12
                      sm12
                      md12
                    >
                      <v-btn outline block color="info"> {{ $t('Update') }}</v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 md12>
                      <v-btn
                        outline
                        @click.native="val.aktif = false"
                        block
                        color="info"
                        >{{ $t("cancel_button") }}
                      </v-btn>
                    </v-flex> -->
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import rez from "../rezervasyon";
import kur from "@/components/app/coper/comp/kur.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import genelaramakod from "@/components/app/coper/comp/genelaramakod.vue";
import tarihcomp from "../../customcomp/tarihim";
import parainput from "../../customcomp/parainput";
import yuzdeinput from "../../customcomp/yuzdeinput";
import tasimatipi from "@/components/app/coper/component/tasimatipi.vue";
import aracalanara from "@/components/app/coper/component/aracalanara.vue";
import rehbersoforara from "@/components/app/coper/component/rehbersoforara.vue";
import rentacarkategori from "@/components/app/coper/component/rentacarkategori.vue";
import rentacararac from "@/components/app/coper/component/rentacararac.vue";
import minisaticieklecomp from "@/components/app/coper/component/minisaticieklecomp.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import tool from "../tools";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import kredikartodemetipi from "@/components/app/coper/comp/kredikartodemetipi.vue";
import kredikartnoara from "@/components/app/coper/comp/kredikartnoara.vue";
import resultDialog from "@/components/app/customcomp/resultDialog.vue"
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

export default {
  components: {
    snackbarcomp,
    resultDialog,
    kur,
    genelarama,
    genelaramakod,
    tarihcomp,
    geneltipara,
    parainput,
    yuzdeinput,
    tasimatipi,
    aracalanara,
    rehbersoforara,
    rentacarkategori,
    rentacararac,
    minisaticieklecomp,
    cariaracomp,
    kredikartodemetipi,
    kredikartnoara,
  },
  watch: {
    "val.kalem.satici.kod": function (val) {
      this.val.kalem.satis.KDVOran = parseFloat(this.val.kalem.satici.KDV);

      var params = {
        AracKod: val,
      };
      tool.http_post(this, "TasimaFiyatKalemTipArama", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.aractipitems = response.body.data;
          } else {
            this.text1 = "Service Unavailable-TasimaFiyatKalemTipArama";
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Service Unavailable-TasimaFiyatKalemTipArama";
          this.snackbar = true;
        }
      );
    },

    secilenkayitlar: function (val) {
      if (this.counter == 0 && this.val.islem != "new") {
        this.counter = this.counter + 1;
      } else {
        if (this.val.kalem.P_RP == "R") {
          this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
        } else {
          this.val.kalem.yet_KisiSayisi = 0;
          this.val.kalem.co1_KisiSayisi = 0;
          this.val.kalem.co2_KisiSayisi = 0;
          this.val.kalem.co3_KisiSayisi = 0;
          this.val.kalem.co4_KisiSayisi = 0;
          this.val.kalem.ekY_KisiSayisi = 0;

          val.forEach((element) => {
            if (element.kisiTip == 0) {
              this.val.kalem.yet_KisiSayisi = this.val.kalem.yet_KisiSayisi + 1;
            } else if (element.kisiTip == 1) {
              this.val.kalem.co1_KisiSayisi = this.val.kalem.co1_KisiSayisi + 1;
            } else if (element.kisiTip == 2) {
              this.val.kalem.co2_KisiSayisi = this.val.kalem.co2_KisiSayisi + 1;
            } else if (element.kisiTip == 3) {
              this.val.kalem.co3_KisiSayisi = this.val.kalem.co3_KisiSayisi + 1;
            } else if (element.kisiTip == 4) {
              this.val.kalem.co4_KisiSayisi = this.val.kalem.co4_KisiSayisi + 1;
            } else if (element.kisiTip == 5) {
              this.val.kalem.ekY_KisiSayisi = this.val.kalem.ekY_KisiSayisi + 1;
            }
          });
        }
      }
    },
    "val.kalem.P_RP": function (val) {
      if (val == "R") {
        this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
      } else {
        this.val.kalem.yet_KisiSayisi = 0;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;

        this.secilenkayitlar.forEach((element) => {
          if (element.kisiTip == 0) {
            this.val.kalem.yet_KisiSayisi = this.val.kalem.yet_KisiSayisi + 1;
          } else if (element.kisiTip == 1) {
            this.val.kalem.co1_KisiSayisi = this.val.kalem.co1_KisiSayisi + 1;
          } else if (element.kisiTip == 2) {
            this.val.kalem.co2_KisiSayisi = this.val.kalem.co2_KisiSayisi + 1;
          } else if (element.kisiTip == 3) {
            this.val.kalem.co3_KisiSayisi = this.val.kalem.co3_KisiSayisi + 1;
          } else if (element.kisiTip == 4) {
            this.val.kalem.co4_KisiSayisi = this.val.kalem.co4_KisiSayisi + 1;
          } else if (element.kisiTip == 5) {
            this.val.kalem.ekY_KisiSayisi = this.val.kalem.ekY_KisiSayisi + 1;
          }
        });
      }
    },
    tumunusec(valsec) {
      this.val.kalem.yet_KisiSayisi = 0;
      this.val.kalem.co1_KisiSayisi = 0;
      this.val.kalem.co2_KisiSayisi = 0;
      this.val.kalem.co3_KisiSayisi = 0;
      this.val.kalem.co4_KisiSayisi = 0;
      this.val.kalem.ekY_KisiSayisi = 0;
      if (valsec == true) {
        for (var i = 0; i < this.val.Kisiler.length; i++) {
          this.secilenkayitlar.push(this.val.Kisiler[i]);
        }
        if (this.val.kalem.P_RP == "R") {
          this.val.kalem.yet_KisiSayisi = this.val.Kisiler.length;
        } else {
          this.secilenkayitlar.forEach((element) => {
            if (element.kisiTip == 0) {
              this.val.kalem.yet_KisiSayisi = this.val.kalem.yet_KisiSayisi + 1;
            } else if (element.kisiTip == 1) {
              this.val.kalem.co1_KisiSayisi = this.val.kalem.co1_KisiSayisi + 1;
            } else if (element.kisiTip == 2) {
              this.val.kalem.co2_KisiSayisi = this.val.kalem.co2_KisiSayisi + 1;
            } else if (element.kisiTip == 3) {
              this.val.kalem.co3_KisiSayisi = this.val.kalem.co3_KisiSayisi + 1;
            } else if (element.kisiTip == 4) {
              this.val.kalem.co4_KisiSayisi = this.val.kalem.co4_KisiSayisi + 1;
            } else if (element.kisiTip == 5) {
              this.val.kalem.ekY_KisiSayisi = this.val.kalem.ekY_KisiSayisi + 1;
            }
          });
        }
      } else {
        this.secilenkayitlar = [];
        this.val.kalem.yet_KisiSayisi = 0;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;
      }

      // if (valsec == true) {
      //   this.secilenkayitlar = this.val.Kisiler;
      // } else {
      //   this.secilenkayitlar = [];
      // }
    },
  },

  props: ["value"],
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  data() {
    return {
      PB:'TRY',
      text1: "",
      snackbar: false,
      aractipitems: [],
      menu2: false,
      menu1: false,
      menualissati: false,
      menuteslimsati: false,
      menumusteslimsati: false,
      ucusnoitems: [],
      rehberdilitems: [],
      transfertipitems: [
        {
          text: this.$t('None'),
          value: "Yok",
        },
        {
          text: this.$t('Golf-course-tasks'),
          value: "Golf Sahası Yapacak",
        },
        {
          text: this.$t('Agency-tasks'),
          value: "Acenta Yapacak",
        },
      ],

      tumunusec: false,
      secilenkayitlar: [],
      dialogShow: false,
      error: "",
      adresler: [],
      search: "",
      selected: [],
      odemeTipi: rez.OdemeTipi,

      tabmodel: "tab-genel",

      kisiSira: [],
      headers: [
        {
          text: "Isim",
          align: "left",
          value: "adSoyad",
          sortable: false,
        },
      ],
      menuItems: [
        {
          title: this.$t('Find-Price')
        },
        {
          title: this.$t('Calculate-Price'),
        },
      ],
    };
  },

  created() {},
  methods: {
      getMaliyetCari(){
      this.val.kalem.maliyetCariKod.kod = this.val.kalem.satici.CariKod;
    },
    kKartKontrol() {
      this.val.kalem.KKartNo = "";
    },
    getparabirimi() {
      return helpers.getparabirimiDefault();
    },
    kalemekle() {
      if(this.val.kalem.yet_KisiSayisi == ''){
          this.snackbar = true;
          this.text1 = this.$t('Number-of-Adults-cannot-be-empty');
          return false;
      }

      if(this.val.kalem.satici.kod == null || this.val.kalem.satici.kod == ""){
          let data ={
          response: {},
          request:{},
          api:'kalemSaticiKontrol',
          type:2,
           message: this.$t('Vendor-cannot-be-empty-Please-add-Seller')
          };
          this.$refs.showMessage.open(data);
          return false;
      }

      if(this.secilenkayitlar.length == 0 ){
         this.text1 = this.$t('Contact-List-cannot-be-empty-Please-add-person');
         this.snackbar = true;
         return false;
      }

      if (this.val.kalem.P_RP == "P") {
      } else {
        // this.val.kalem.yet_Satis = 0;
        this.val.kalem.co1_Satis = 0;
        this.val.kalem.co2_Satis = 0;
        this.val.kalem.co3_Satis = 0;
        this.val.kalem.co4_Satis = 0;
        this.val.kalem.ekY_Satis = 0;

        //this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;
      }

      this.val.kalem.kalemDiger = null;
      this.val.kalem.kalemArac = null;
      //this.val.kalem.kalemRentACar = null
      this.val.kalem.kalemVize = null;
      this.val.kalem.kalemAcente = null;
      this.val.kalem.kalemCharter = null;
      this.val.kalem.kalemFeribot = null;
      this.val.kalem.kalemGemi = null;
      this.val.kalem.kalemGolf = null;
      this.val.kalem.kalemMuze = null;
      this.val.kalem.kalemOtel = null;
      this.val.kalem.kalemRehber = null;
      this.val.kalem.kalemRestaurant = null;
      this.val.kalem.kalemSigorta = null;
      this.val.kalem.kisiSira = [];

      this.secilenkayitlar.forEach((element) => {
        var a = this.val.Kisiler.indexOf(element);

        if (a != -1) {
          this.val.kalem.kisiSira.push(a);
        }
      });

      this.val.Rez.kalemler.push(this.val.kalem);
      this.val.islem = "new";
      this.val.aktif = false;
    },
    kalemguncelle() {

      if(this.val.kalem.yet_KisiSayisi == ''){
          this.snackbar = true;
          this.text1 = this.$t('Number-of-Adults-cannot-be-empty');
          return false;
      }

      if(this.val.kalem.satici.kod == null || this.val.kalem.satici.kod == ""){
          let data ={
          response: {},
          request:{},
          api:'kalemSaticiKontrol',
          type:2,
           message: this.$t('Vendor-cannot-be-empty-Please-add-Seller')
          };
          this.$refs.showMessage.open(data);
          return false;
      }


      if(this.secilenkayitlar.length == 0 ){
            this.text1 = this.$t('Contact-List-cannot-be-empty-Please-add-person');
         this.snackbar = true;
         return false;
      }

      if (this.val.kalem.P_RP == "P") {
      } else {
        this.val.kalem.co1_Satis = 0;
        this.val.kalem.co2_Satis = 0;
        this.val.kalem.co3_Satis = 0;
        this.val.kalem.co4_Satis = 0;
        this.val.kalem.ekY_Satis = 0;

        //this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length;
        this.val.kalem.co1_KisiSayisi = 0;
        this.val.kalem.co2_KisiSayisi = 0;
        this.val.kalem.co3_KisiSayisi = 0;
        this.val.kalem.co4_KisiSayisi = 0;
        this.val.kalem.ekY_KisiSayisi = 0;
      }

      this.val.kalem.kalemDiger = null;
      this.val.kalem.kalemArac = null;
      // this.val.kalem.kalemRentACar = null
      this.val.kalem.kalemVize = null;
      this.val.kalem.kalemAcente = null;
      this.val.kalem.kalemCharter = null;
      this.val.kalem.kalemFeribot = null;
      this.val.kalem.kalemGemi = null;
      this.val.kalem.kalemGolf = null;
      this.val.kalem.kalemMuze = null;
      this.val.kalem.kalemOtel = null;
      this.val.kalem.kalemRehber = null;
      this.val.kalem.kalemRestaurant = null;
      this.val.kalem.kalemSigorta = null;

      this.val.kalem.kisiSira = [];

      this.secilenkayitlar.forEach((element) => {
        var a = this.val.Kisiler.indexOf(element);

        if (a != -1) {
          this.val.kalem.kisiSira.push(a);
        }
      });

      this.val.Rez.kalemler.splice(this.val.recordno, 1, this.val.kalem);
      this.val.aktif = false;
      this.val.islem = "new";
    },

    KisiTipToStr(tip) {
      return rez.KisiTipToStr(tip);
    },
    menuClick: menuClick,
    SaticiTipToStr(tip) {
      return rez.SaticiTipToStr(tip);
    },
    setSelected(v) {
      this.selected = v;
    },
    setDialogShow(v) {
      this.dialogShow = v;
    },

    close() {
      this.value.dialogShow = false;
      setTimeout(() => {
        this.value.kalem = Object.assign({}, rez.Kalem());

        this.value.editedIndex = -1;
      }, 300);
    },

    modalOk() {
      this.value.kalem.kisiSira = [];
      for (var i = 0; i < this.selected.length; i++) {
        this.value.kalem.kisiSira.push(this.selected[i].kisiSira);
      }

      if (this.value.editedIndex > -1) {
        Object.assign(
          this.value.Rez.kalemler[this.value.editedIndex],
          this.value.kalem
        );
      } else {
        this.value.Rez.kalemler.push(this.value.kalem);
      }
      this.close();
    },
  },
  mounted() {
    if (this.val.islem == "new") {
     
        var credentials = JSON.parse(window.localStorage.getItem("credentials"));
    this.PB=credentials.ParaBirimi;
    var yazpb=this.PB;
    if (yazpb=="TRY"){
      yazpb="TL";
    }
     this.val.kalem.satisPara.paraBirimi=yazpb;
      this.val.kalem.komisyonPara.paraBirimi=yazpb;
      this.val.kalem.alisPara.paraBirimi=yazpb;
     
      this.val.kalem.masrafMerkezi = this.value.Rez.masrafMerkezi;
      this.secilenkayitlar = [];

      for (var i = 0; i < this.value.Kisiler.length; i++) {
        this.secilenkayitlar.push(this.value.Kisiler[i]);
      }
    } else {
      this.val.kalem.masrafMerkezi = this.value.Rez.masrafMerkezi;
      this.secilenkayitlar = [];
      for (var i = 0; i < this.value.kalem.kisiSira.length; i++) {
        this.secilenkayitlar.push(
          this.value.Rez.adresler[this.value.kalem.kisiSira[i]]
        );
      }
    }

    var params = {};
    tool.http_post(this, "UcusNoList", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.ucusnoitems = response.body.data;
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
        }
      },
      (response) => {
       this.text1 = $t('Error-Occured-Please-Try-Again')
        this.snackbar = true;
      }
    );

    var params = {};
    tool.http_post(this, "DillerList", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.rehberdilitems = response.body.data;
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
        }
      },
      (response) => {
       this.text1 = $t('Error-Occured-Please-Try-Again')
        this.snackbar = true;
      }
    );
  },
};

function menuClick(v) {}
</script>